import Vue from 'vue';

Vue.component('ozi-button', () => import('./OziButton.vue'));
Vue.component('ozi-confirm-text', () => import('./OziConfirmText.vue'));
Vue.component('ozi-date-picker', () => import('./OziDatePicker.vue'));
Vue.component('ozi-loading', () => import('./OziLoading.vue'));
Vue.component('ozi-modal', () => import('./OziModal.vue'));
Vue.component('ozi-note', () => import('./OziNote.vue'));
Vue.component('ozi-select', () => import('./OziSelect.vue'));
Vue.component('ozi-table', () => import('./OziTable.vue'));
Vue.component('ozi-textarea', () => import('./OziTextArea.vue'));
Vue.component('ozi-text-field', () => import('./OziTextField.vue'));
